import { computed, Injectable, signal } from '@angular/core';

export type AnalyticsDrawMode = 'point' | 'polygon' | null;

@Injectable({
  providedIn: 'root',
})
export class AnalyticsDrawStateService {
  private readonly mainModeState = signal<AnalyticsDrawMode>(null);
  private readonly splitModeState = signal<AnalyticsDrawMode>(null);

  readonly mainMode = this.mainModeState.asReadonly();
  readonly splitMode = this.splitModeState.asReadonly();

  readonly isMainPointActive = computed(() => this.mainMode() === 'point');
  readonly isMainPolygonActive = computed(() => this.mainMode() === 'polygon');
  readonly isSplitPointActive = computed(() => this.splitMode() === 'point');
  readonly isSplitPolygonActive = computed(
    () => this.splitMode() === 'polygon',
  );

  setMainMode(mode: AnalyticsDrawMode): void {
    this.mainModeState.set(mode);
  }

  setSplitMode(mode: AnalyticsDrawMode): void {
    this.splitModeState.set(mode);
  }
}
